import { scheduleDebouncedUnsubscribeAtom } from '@store/atoms/mqtt/subscription/debouncedUnsubscribeAtom';
import { subscriberSetAtomFamily } from '@store/atoms/mqtt/subscription/subscriptionAtoms';
import { setDebugLabels } from '@store/atoms/mqtt/utils/atomUtils';
import {
  hasSubscriber,
  scheduleUnsubscribe,
} from '@store/atoms/mqtt/utils/subscriberUtils';
import { isValidUnsubscriptionTopic } from '@store/atoms/mqtt/utils/topicUtils';
import { atom } from 'jotai';

export const unsubscribeWithLifecycleAtom = atom(
  null,
  (
    get,
    set,
    {
      topic,
      subscriberId,
      immediate = false,
    }: {
      topic: string;
      subscriberId: string;
      immediate?: boolean;
    },
  ) => {
    if (!isValidUnsubscriptionTopic(topic, subscriberId)) {
      return;
    }

    const currentSubscribers = get(subscriberSetAtomFamily(topic));

    if (!hasSubscriber(currentSubscribers, subscriberId, topic)) {
      return;
    }

    scheduleUnsubscribe(
      set,
      scheduleDebouncedUnsubscribeAtom,
      topic,
      subscriberId,
      immediate,
    );
  },
);

setDebugLabels({
  unsubscribeWithLifecycleAtom,
});
